export default class DateFilterComparisonOptions {
  static get WithinTheLast() {
    return {
      id: 'within_the_last',
    };
  }

  static get MoreThan() {
    return {
      id: 'more_than',
    };
  }

  static get Between() {
    return {
      id: 'between',
    };
  }

  static get Before() {
    return {
      id: 'before',
    };
  }

  static get After() {
    return {
      id: 'after',
    };
  }

  static get InRange() {
    return {
      id: 'in_range',
    };
  }

  static get all() {
    return [
      DateFilterComparisonOptions.WithinTheLast,
      DateFilterComparisonOptions.MoreThan,
      DateFilterComparisonOptions.Between,
      DateFilterComparisonOptions.InRange,
      DateFilterComparisonOptions.Before,
      DateFilterComparisonOptions.After,
    ];
  }
}
